"use client";

import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    // Logueamos el error en consola para debugging
    console.error("Unhandled exception caught in GlobalError:", error);
  }, [error]);

  return (
    <html>
      <body>
        {/* 
          NextError es la página de error por defecto de Next.js. 
          Su prop `statusCode` es obligatoria, pero como en App Router no
          tenemos el código HTTP, pasamos 0 para un mensaje genérico.
        */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
